import { pricingPlans } from '../data/pricingData';
import { Link } from 'react-router-dom';
import { FaCheck, FaStar, FaChevronRight } from 'react-icons/fa';
import './StudyPlansFees.css';

const StudyPlansFees = () => {

  return (
    <div className="study-plans-page">
      <div className="pricing-hero">
        <div className="pricing-hero-overlay"></div>
        <div className="container">
          <div className="pricing-hero-content">
            <h1>Study Plans & Fees</h1>
            <p>Choose the plan that fits your needs and budget</p>
          </div>
        </div>
      </div>

      <section className="pricing-section">
        <div className="container">
          <div className="section-intro">
            <h2>Flexible Pricing Plans</h2>
            <p>
              We offer flexible pricing plans to suit different learning needs and schedules. 
              All plans include one-on-one classes with qualified teachers, flexible scheduling, 
              and comprehensive learning materials.
            </p>
          </div>

          {/* Pricing Table */}
          <div className="pricing-table-wrapper">
            <div className="pricing-table-container">
              <table className="pricing-table">
                <thead>
                  <tr>
                    <th className="plan-name-col">Plan</th>
                    <th className="price-col">Price</th>
                    <th className="classes-col">Classes/Week</th>
                    <th className="duration-col">Duration</th>
                    <th className="features-col">Key Features</th>
                    <th className="action-col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {pricingPlans.map((plan, index) => (
                    <tr 
                      key={plan.id} 
                      className={`pricing-row ${plan.popular ? 'popular-row' : ''}`}
                    >
                      <td className="plan-name-cell">
                        <div className="plan-name-wrapper">
                          <div className="plan-name-header">
                            <h3>{plan.name}</h3>
                            {plan.popular && (
                              <span className="popular-badge-table">
                                <FaStar /> Most Popular
                              </span>
                            )}
                          </div>
                          <p className="plan-subtitle-table">{plan.classes}</p>
                        </div>
                      </td>
                      <td className="price-cell">
                        <div className="price-wrapper">
                          <span className="currency-table">{plan.currency}</span>
                          <span className="amount-table">{plan.price}</span>
                          <span className="duration-table">/{plan.type}</span>
                        </div>
                      </td>
                      <td className="classes-cell">
                        <span className="classes-value">{plan.classesPerWeek}</span>
                      </td>
                      <td className="duration-cell">
                        <span className="duration-value">{plan.classDuration}</span>
                      </td>
                      <td className="features-cell">
                        <div className="features-list-table">
                          {plan.features.slice(0, 3).map((feature, idx) => (
                            <div key={idx} className="feature-item-table">
                              <FaCheck className="feature-check" />
                              <span>{feature}</span>
                            </div>
                          ))}
                          {plan.features.length > 3 && (
                            <div className="more-features">
                              +{plan.features.length - 3} more features
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="action-cell">
                        <Link 
                          to="/free-trial" 
                          className={`table-action-btn ${plan.popular ? 'popular-btn' : ''}`}
                        >
                          Get Started
                          <FaChevronRight className="btn-arrow" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pricing-notes">
            <h3>Additional Information</h3>
            <div className="notes-grid">
              <div className="note-item">
                <h4>🎁 Family Discount</h4>
                <p>Get 10% off for 2 students, 15% off for 3+ students from the same family</p>
              </div>
              <div className="note-item">
                <h4>📅 Flexible Scheduling</h4>
                <p>Choose your preferred class timings that fit your schedule</p>
              </div>
              <div className="note-item">
                <h4>🔄 Cancel Anytime</h4>
                <p>No long-term commitments. Cancel or pause your subscription anytime</p>
              </div>
              <div className="note-item">
                <h4>💯 Money Back Guarantee</h4>
                <p>7-day money-back guarantee if you're not satisfied</p>
              </div>
            </div>
          </div>

          <div className="cta-section-inline">
            <h3>Ready to Start Learning?</h3>
            <p>Try our service with a free trial class - no credit card required!</p>
            <Link to="/free-trial" className="btn btn-secondary">Start Free Trial</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StudyPlansFees;
